import { ComponentType } from 'react';
import { ServiceChartCard } from './ServiceCards/ServiceChartCard';
import { ServiceTableCard } from './ServiceCards/ServiceTableCard';
import { MatchChartCard } from './MatchCards/MatchChartCard';
import { MatchTableCard } from './MatchCards/MatchTableCard';
import { EndReasonTypeChartCard } from './EndReasonTypeCards/EndReasonTypeChartCard';
import { EndReasonTypeTableCard } from './EndReasonTypeCards/EndReasonTypeTableCard';
import { FafsaChartCard } from './FafsaDashboard/FafsaChartCard';
import { FafsaTableCard } from './FafsaDashboard/FafsaTableCard';
import { GenderChartCard } from './GenderDashboard/GenderChartCard';
import { GenderTableCard } from './GenderDashboard/GenderTableCard';
import { NotificationsCard } from './NotificationsDashboard/NotificationsCard';
import { TotalStudentsCard } from './StudentDashboard/TotalStudentsCard';
import { SchoolEnrollmentCard } from './SchoolEnrollmentDashboard/SchoolEnrollmentCard';
import { ParticipantsChartCard } from './ParticipantsCards/ParticipantsChartCard';
import { ParticipantsTableCard } from './ParticipantsCards/ParticipantsTableCard';
import { EligibilityChartCard } from './EligibilityCards/EligibilityChartCard';
import { EligibilityTableCard } from './EligibilityCards/EligibilityTableCard';
import { LkDashboardCardId } from './types';
import { RaceTableCard } from './RaceDashboard/RaceTableCard';
import { RaceChartCard } from './RaceDashboard/RaceChartCard';
import { EthnicityTableCard } from './EthnicityDashboard/EthnicityTableCard';
import { EthnicityChartCard } from './EthnicityDashboard/EthnicityChartCard';
import { IEPTableCard } from './IEPDashboard/IEPTableCard';
import { IEPChartCard } from './IEPDashboard/IEPChartCard';
import { LEPTableCard } from './LEPDashboard/LEPTableCard';
import { LEPChartCard } from './LEPDashboard/LEPChartCard';
import { GPAChartCard } from './GPADashboard/GPAChartCard';
import { GPATableCard } from './GPADashboard/GPATableCard';
import { StudentServiceChartCard } from './StudentServiceDashboard/StudentServiceChartCard';
import { StudentServiceTableCard } from './StudentServiceDashboard/StudentServiceTableCard';
import { GradeLevelChartCard } from './GradeLevelDashboard/GradeLevelChartCard';
import { GradeLevelTableCard } from './GradeLevelDashboard/GradeLevelTableCard';
import { EnrollmentByAdvisorChartCard } from './EnrollmentByAdvisorDashboard/EnrollmentByAdvisorChartCard';
import { EnrollmentByAdvisorTableCard } from './EnrollmentByAdvisorDashboard/EnrollmentByAdvisorTableCard';

type DashboardCardComponent = ComponentType<{}>;

export const DASHBOARD_CARD_REGISTRY: Record<number, DashboardCardComponent> = {
  [LkDashboardCardId.ServiceChart]: ServiceChartCard,
  [LkDashboardCardId.ServiceTable]: ServiceTableCard,
  [LkDashboardCardId.MatchChart]: MatchChartCard,
  [LkDashboardCardId.MatchTable]: MatchTableCard,
  [LkDashboardCardId.Notifications]: NotificationsCard,
  [LkDashboardCardId.TotalStudents]: TotalStudentsCard,
  [LkDashboardCardId.SchoolEnrollment]: SchoolEnrollmentCard,
  [LkDashboardCardId.FafsaChart]: FafsaChartCard,
  [LkDashboardCardId.FafsaTable]: FafsaTableCard,
  [LkDashboardCardId.EndReasonTypeTable]: EndReasonTypeTableCard,
  [LkDashboardCardId.EndReasonTypeChart]: EndReasonTypeChartCard,
  [LkDashboardCardId.ParticipantsChart]: ParticipantsChartCard,
  [LkDashboardCardId.ParticipantsTable]: ParticipantsTableCard,
  [LkDashboardCardId.GenderChart]: GenderChartCard,
  [LkDashboardCardId.GenderTable]: GenderTableCard,
  [LkDashboardCardId.EligibilityChart]: EligibilityChartCard,
  [LkDashboardCardId.EligibilityTable]: EligibilityTableCard,
  [LkDashboardCardId.RaceChart]: RaceChartCard,
  [LkDashboardCardId.RaceTable]: RaceTableCard,
  [LkDashboardCardId.EthnicityChart]: EthnicityChartCard,
  [LkDashboardCardId.EthnicityTable]: EthnicityTableCard,
  [LkDashboardCardId.IEPChart]: IEPChartCard,
  [LkDashboardCardId.IEPTable]: IEPTableCard,
  [LkDashboardCardId.LEPChart]: LEPChartCard,
  [LkDashboardCardId.LEPTable]: LEPTableCard,
  [LkDashboardCardId.GradeLevelTable]: GradeLevelTableCard,
  [LkDashboardCardId.GradeLevelChart]: GradeLevelChartCard,
  [LkDashboardCardId.StudentServiceChart]: StudentServiceChartCard,
  [LkDashboardCardId.StudentServiceTable]: StudentServiceTableCard,
  [LkDashboardCardId.GPAChart]: GPAChartCard,
  [LkDashboardCardId.GPATable]: GPATableCard,
  [LkDashboardCardId.EnrollmentByAdvisorChart]: EnrollmentByAdvisorChartCard,
  [LkDashboardCardId.EnrollmentByAdvisorTable]: EnrollmentByAdvisorTableCard,
};
